import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import config from 'config';

import { errorClear, errorSet } from 'actions/error';
import { authClient } from 'actions/oauth';

import OauthCard from './OauthCard';

import {
  Container,
  InnerContainer
} from './Styled';

import { getQueryString } from 'utils';

const BASENAME = config.site.baseName;

const OAuthContainer = ({ client = {}, authClient, user, error, loading, ...props }) => {
  const search = props.location.search;
  const qs = getQueryString(props);

  useEffect(
    function getClient () {
      errorClear();
      authClient(search);
    },
    [ authClient, errorClear, search ]
  );

  return (
    <Container>
      <InnerContainer>
        <OauthCard
          qs={qs} 
          user={user}
          client={client}
          loading={loading}
          error={error.message}
          apiUrl={config.api.baseUrl + config.api.url}
          baseUrl={`${BASENAME ? '/' : ''}${BASENAME}`}
          hasClient={client && client.id === qs.get('client_id')}
        />
      </InnerContainer>
    </Container>
  );
};

const mapDispatchToProps = {
  errorSet,
  authClient,
  errorClear
};

const mapStateToProps = ({ loading, oauth, session, error }) => ({
  client: oauth.client,
  error: error,
  loading: loading.loadingOauthClient,
  user: {
    email: session.email_address,
    name:  `${session.first_name} ${session.last_name}`
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OAuthContainer)
);
